import React, { useEffect, useState } from 'react';
import EnmaeyaAvatar from '../chat_container/Avatar';
import { useLang } from '../../Contexts/LanguageContext';
import { translateThinkingStep } from '../../i18n/thinkingTranslations';
import './ThinkingMessage.css';

interface ThinkingMessageProps {
    isOpen: boolean;
    steps: string[];
}

const ThinkingMessage: React.FC<ThinkingMessageProps> = ({ isOpen, steps }) => {
    const { lang, isRTL } = useLang();
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        const interval = setInterval(() => {
            setDotCount(d => (d % 3) + 1);
        }, 500);
        return () => clearInterval(interval);
    }, []);

    const dots = '.'.repeat(dotCount);

    return (
        <div className="supervisor-thinking" dir="ltr" aria-live="polite">
            <div className="supervisor-thinking-avatar">
                <EnmaeyaAvatar status={isOpen ? 'online' : 'offline'} />
            </div>
            <div className="supervisor-thinking-body" dir={isRTL ? 'rtl' : 'ltr'}>
                <div className="supervisor-thinking-header" style={{ fontFamily: isRTL ? "'Noto Kufi Arabic', sans-serif" : 'inherit' }}>
                    {isRTL ? `أفكر${dots}` : `Thinking${dots}`}
                </div>
                {steps.length > 0 && (
                    <ul className="supervisor-thinking-steps">
                        {steps.map((step, i) => (
                            <li key={i} className="supervisor-thinking-step" style={{ fontFamily: isRTL ? "'Noto Kufi Arabic', sans-serif" : 'inherit' }}>
                                <span className="supervisor-thinking-step-icon">{isRTL ? '←' : '→'}</span>
                                {lang === 'ar' ? translateThinkingStep(step) : step}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ThinkingMessage;
